<template>
  <div>
    <el-row type="flex" align="middle" class="top-wrap" style="z-index:1">
      <div class="logo-box" v-show="systemImg"><img :src="systemImg" /></div>
      <div class="separator" v-show="systemImg"></div>
      <div class="name" :class="{ 'm-l-30': !systemImg }">{{ systemName }}</div>
    </el-row>
    <el-row type="flex" class="content-wrap" :style="bgStyleObj">
      <div class="pos-abs w-100p login-bg" style="min-width:1280px" v-if="systemBgImg">
        <img class="w-100p" :src="systemBgImg">
      </div>
      <el-col :span="14">
        <el-row class="m-r-110" type="flex" justify="end">
          <template v-if="aniamtionType != 'null'">
            <!-- 做个兼容，当animationType为空时默认显示工作台动画 -->
            <desk-animation
              :stop="deskAnimationMove"
              v-if="!aniamtionType || aniamtionType == 'desk'">
            </desk-animation>
          </template>
          <!-- <div class="lamp-bg m-t-35" :class="{'lamp-default': !(isLamp || form.account || form.password), 'lamp-active': isLamp || form.account || form.password}">
            <div class="table-bg table-warp1" :class="{ 'stop': isLamp || form.account || form.password}"></div>
            <div class="table-bg table-warp2" :class="{ 'stop': isLamp || form.account || form.password}"></div>
            <div class="table-bg table-warp3" :class="{ 'stop': isLamp || form.account || form.password}"></div>
          </div> -->
        </el-row>
      </el-col>
      <el-col :span="10">
        <div class="login-wrap bg-wh bor-ra-2">
          <div class="form-box">
            <el-form :model="form" :rules="rules2" ref="form" label-position="left" label-width="0px">
              <div class="tx-c fw-b" :class="{ 'm-b-36': !isSmall, 'm-b-15': isSmall, 'fz-24': !isSmall, 'fz-22': isSmall }">{{loginTitle}}</div>
              <el-form-item prop="account" class="m-l-0" :class="{ 'm-b-30': !isSmall, 'm-b-24': isSmall }">
                <el-row type="flex" align="middle" class="input-wrap" :class="{ 'input-wrap-active': isUser }">
                  <span class="fz-18" :class="{ 'm-l-12': !isSmall, 'm-r-12': !isSmall, 'm-l-10': isSmall, 'm-r-10': isSmall }"><i class="fa fa-user" :class="{ 'c-ccc': !isUser, 'c-03a': isUser }"></i></span>
                  <input type="text" v-model.trim="form.account" auto-complete="off" placeholder="账号" @focus="onFocus1" @keydown="onBlur1(0)" @blur="onBlur1(1)" @keyup.enter="handleSubmit2" />
                  <span class="fz-18 c-ccc" :class="{ 'm-l-12': !isSmall, 'm-r-12': !isSmall, 'm-l-10': isSmall, 'm-r-10': isSmall }" v-if="form.account" @click="form.account = ''"><i class="fa fa-times-circle"></i></span>
                </el-row>
              </el-form-item>
              <el-form-item prop="password" class="m-l-0" :class="{ 'm-b-26': !isSmall, 'm-b-22': isSmall }">
                <el-row type="flex" align="middle" class="input-wrap" :class="{ 'input-wrap-active': isPwd }">
                  <span class="fz-18" :class="{ 'm-l-12': !isSmall, 'm-r-12': !isSmall, 'm-l-10': isSmall, 'm-r-10': isSmall }"><i class="fa fa-unlock-alt" style="vertical-align: middle;" :class="{ 'c-ccc': !isPwd, 'c-03a': isPwd }"></i></span>
                  <input type="password" v-model.trim="form.password" auto-complete="off" placeholder="密码" @focus="onFocus2" @keydown="onBlur2(0)" @blur="onBlur2(1)" @keyup.enter="handleSubmit2" />
                  <span class="fz-18 c-ccc" :class="{ 'm-l-12': !isSmall, 'm-r-12': !isSmall, 'm-l-10': isSmall, 'm-r-10': isSmall }" v-if="form.password" @click="form.password = ''"><i class="fa fa-times-circle"></i></span>
                </el-row>
              </el-form-item>
              <el-form-item v-show="requireVerify" prop="verifyCode" class="m-b-38">
                <el-input type="text" v-model="form.verifyCode" auto-complete="off" placeholder="验证码" class="fl" :class="{'w-80': isSmall, 'w-120': !isSmall}"></el-input>
                <img :src="verifyUrl" @click="refreshVerify()" class="fl m-t-5 m-l-5" :class="{'w-80': isSmall}" />
              </el-form-item>
              <el-checkbox v-model="checked" class="m-t-10" :class="{'m-b-26': !isSmall, 'm-b-20': isSmall }">记住密码</el-checkbox>
              <button type="button" :class="{ 'active-color': !disable, 'h-40': !isSmall, 'h-32': isSmall }" style="width:100%;" :disabled="disable" @click="handleSubmit2">登录</button>
            </el-form>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row class="bottom-wrap fz-14 c-5a5f66" v-if="systemCopyRight">COPYRIGHT © {{systemCopyRight}}</el-row>
    <el-row class="bottom-wrap fz-14 c-5a5f66" v-else>COPYRIGHT © 广东洪睿信息科技有限公司 粤ICP备14074753号</el-row>
  </div>
</template>

<script>
  import http from '../../assets/js/http'
  import deskAnimation from './loginAnimation/deskAnimation'

  export default {
    data() {
      return {
        title: '',
        systemName: '',
        loginTitle: '',
        systemImg: '',
        systemBgImg: '',
        systemCopyRight: '',
        aniamtionType: '123',
        disable: true,
        form: {
          account: '',
          password: '',
          verifyCode: ''
        },
        requireVerify: false,
        verifyUrl: '',
        verifyImg: window.HOST + 'admin/base/getVerify',
        rules2: {
          account: [
            { required: true, message: '请输入账号', trigger: 'blur' }
          ],
          password: [
            { required: true, message: '请输入密码', trigger: 'blur' }
          ],
          verifyCode: [
            { required: false, message: '请输入验证码', trigger: 'blur' }
          ]
        },
        checked: false,
        isUser: false,
        isPwd: false,
        isLamp: false,
        screenWidth: '',
        isSmall: false,
        bgStyleObj: {
          backgroundColor: ''
        }
      }
    },
    methods: {
      refreshVerify() {
        this.verifyUrl = ''
        setTimeout(() => {
          this.verifyUrl = this.verifyImg + '?v=' + moment().unix()
        }, 300)
      },
      onFocus1() {
        this.isUser = true
        this.isLamp = true
      },
      onFocus2() {
        this.isPwd = true
        this.isLamp = true
      },
      onBlur1(type) {
        if (this.$refs.form) {
          this.$refs.form.validateField('account', (valid) => {
            if (valid || !this.form.password) {
              this.disable = true
            } else {
              this.disable = false
            }
          })
        }
        if (type == 1) {
          this.isUser = false
          this.isLamp = false
        }
      },
      onBlur2(type) {
        if (this.$refs.form) {
          this.$refs.form.validateField('password', (valid) => {
            if (valid || !this.form.account) {
              this.disable = true
            } else {
              this.disable = false
            }
          })
        }
        if (type == 1) {
          this.isPwd = false
          this.isLamp = false
        }
      },
      validate() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.disable = false
          } else {
            this.disable = true
          }
        })
      },
      handleSubmit2() {
        this.validate()
        if (this.disable == true) {
          return false
        }
        let data = {}
        if (this.requireVerify) {
          data.username = this.form.account
          data.password = this.form.password
          data.verifyCode = this.form.verifyCode
        } else {
          data.username = this.form.account
          data.password = this.form.password
        }
        if (this.checked) {
          data.isRemember = 1
        } else {
          data.isRemember = 0
        }
        this.apiPost('admin/base/login', data).then((res) => {
          if (res.code != 200) {
            _g.dealError(this, res)
          } else {
            this.refreshVerify()
            if (this.checked) {
              Cookies.set('rememberPwd', true, { expires: 1 })
            }
            _g.resetCommonData(this, res.data)
            _g.toastMsg(this, 'success', '登录成功')
          }
        })
      },
      checkIsRememberPwd() {
        if (Cookies.get('rememberPwd')) {
          let data = {
            rememberKey: Lockr.get('rememberKey')
          }
          this.apiPost('admin/base/relogin', data).then((res) => {
            console.log('relogin res = ', _g.j2s(res))
            if (res.code == 200) {
              _g.resetCommonData(this, res.data)
            } else {
              _g.dealError(this, res)
            }
          })
        }
      },
      // 7天内不该密码,token不变情况下自动登录
      automaticLogin() {
        if (Cookies.get('tokenKey') && Cookies.get('tokenKey') == Lockr.get('token')) {
          var data = {
            menusList: Lockr.get('menus'),
            menusThreeList: Lockr.get('menusThreeList'),
            rememberKey: Lockr.get('rememberKey'),
            authList: Lockr.get('authList'),
            userInfo: Lockr.get('userInfo'),
            token: Lockr.get('token')
          }
          _g.resetCommonData(this, data)
          _g.updateMenus()
        }
      },
      initScreenWidth() {
        if (this.screenWidth <= 1500) {
          this.isSmall = true
        } else {
          this.isSmall = false
        }
        console.log(this.isSmall)
      }
    },
    mounted() {
      this.screenWidth = document.body.clientWidth
      this.initScreenWidth()
      window.onresize = () => {
        this.screenWidth = document.body.clientWidth
        this.initScreenWidth()
      }
    },
    created() {
      this.checkIsRememberPwd()
      this.automaticLogin()
      this.apiPost('admin/base/getConfigs').then((res) => {
        if (res.code == 200) {
          document.title = res.data.SYSTEM_NAME
          this.systemName = res.data.SYSTEM_NAME
          this.loginTitle = !_g.isRealEmpty(res.data.LOGIN_TITLE) ? res.data.LOGIN_TITLE : res.data.SYSTEM_NAME
          this.systemImg = !_g.isRealEmpty(res.data.SYSTEM_LOGO) ? window.imgUrl + res.data.SYSTEM_LOGO : ''
          this.systemBgImg = !_g.isRealEmpty(res.data.LOGIN_BG_IMG) ? window.imgUrl + res.data.LOGIN_BG_IMG : ''
          this.systemCopyRight = res.data.COPYRIGHT
          this.aniamtionType = res.data.ANIMATION_FRAME
          if (res.data.LOGIN_BG_COLOR) {
            this.bgStyleObj = {
              backgroundColor: res.data.LOGIN_BG_COLOR
            }
          }
          Lockr.set('USE_WECHAT_WORK', res.data.USE_WECHAT_WORK)
          Lockr.set('IS_LOG', res.data.IS_LOG)
          if (parseInt(res.data.IDENTIFYING_CODE)) {
            this.requireVerify = true
            this.rules2.verifyCode[0].required = true
          }
        } else {
          _g.dealError(this, res)
        }
      })
      this.verifyUrl = this.verifyImg
    },
    computed: {
      deskAnimationMove() {
        return this.isLamp || !_g.isRealEmpty(this.form.account) || !_g.isRealEmpty(this.form.account)
      }
    },
    components: {
      deskAnimation
    },
    mixins: [http]
  }
</script>

<style scoped>
  .el-form-item {
    margin-bottom: 18px !important;
  }
  .verify-pos {
    position: absolute;
    right: 100px;
    top: 0px;
  }
  .top-wrap {
    width: 100%;
    height: 70px;
    background-color: #ffffff;
  }
  .top-wrap .logo-box {
    height: 40px;
    line-height: 40px;
    padding-left: 30px;
  }
  .top-wrap .logo-box img {
    height: 40px;
  }
  .top-wrap .name {
    height: 70px;
    line-height: 70px;
    font-size: 20px;
    font-weight: 600;
    color: #333333;
  }
  .top-wrap .separator {
    height: 24px;
    border-left: 1px solid #e5e5e5;
    margin: 0 20px;
  }
  .content-wrap {
    position: fixed;
    top: 70px;
    bottom: 0;
    left: 0;
    right: 0;
    /*background: url(../../assets/images/box.png);*/
  }
  .bottom-wrap {
    position: fixed;
    left: 0;right: 0;
    bottom: 55px;
    text-align: center;
  }
  .content-wrap .active-color {
    background-color: #03a9f4;
    border: 1px solid #0398db;
  }
  .content-wrap button {
    width: 100%;
    height: 40px;
    color: #ffffff;
    border-radius: 4px;
    outline: none;
    background-color: #9addfb;
    border: 1px solid #8ac6e1;
  }
  .content-wrap button.active-color:hover {
    background-color: #1db2f5;
    border: 1px solid #1da3df;
  }
  .content-wrap button.active-color:active {
    background-color: #0398db;
    border: 1px solid #0389c5;
    color: #e5e5e5;
  }
  /*.lamp-bg {
    position: relative;
    width: 640px;
    height: 640px;
    background-size: 100%;
  }*/
  /*.content-wrap .lamp-default {
    background: url('../../assets/images/lamp-default.png') no-repeat;
  }
  .content-wrap .lamp-active {
    background: url('../../assets/images/lamp-active.png') no-repeat;
  }
  .content-wrap .table-bg {
    position: absolute;
    width: 140px;
    height: 180px;
  }*/
  /*.content-wrap .table-warp1 {
    bottom: 180px;
    background: url(../../assets/images/table1.png) no-repeat;
    animation: move1 2s linear infinite alternate;
    animation-delay: 0s;
  }
  .content-wrap .table-warp2 {
    left: 210px;
    top: 60px;
    background: url(../../assets/images/table2.png) no-repeat;
    animation: move2 2s linear infinite alternate;
    animation-delay: .5s;
  }
  .content-wrap .table-warp3 {
    right: 70px;
    top: 80px;
    background: url(../../assets/images/table3.png) no-repeat;
    animation: move3 2s linear infinite alternate;
    animation-delay: 1s;
  }*/
  .content-wrap .input-wrap {
    width: 100%;
    height: 40px;
    border-radius: 0;
    background-color: #ffffff;
    border: 1px solid #e5e5e5;
  }
  .content-wrap .input-wrap input {
    width: 160px;
  }
  .content-wrap .input-wrap-active {
    border: 1px solid #03a9f4;
  }
  .content-wrap input {
    border: 0;
    outline: none;
  }
  /*.content-wrap .stop {
    animation-play-state: paused;
  }*/
  .login-wrap {
    width: 390px;
    min-height: 400px;
    margin-top: 160px;
  }
  .login-wrap .form-box {
    padding: 50px 75px;
    box-shadow: 0px 10px 30px 0px rgba(0, 0, 0, 0.1);
  }
  .login-bg {
    top: 50%;
    margin-top: -50%;
    z-index: -1;
  }
  /*@keyframes move1 {
    from { left: 0; bottom: 180px; }
    to { left: 40px; bottom: 220px; }
  }
  @keyframes move2 {
    from { left: 210px; top: 60px; }
    to { left: 250px; top: 20px; }
  }
  @keyframes move3 {
    from { right: 70px; top: 80px; }
    to { right: 30px; top: 40px; }
  }*/
  @media (max-width: 1500px) {
    .el-form-item {
      margin-bottom: 10px !important;
    }
    .top-wrap {
      height: 60px;
    }
    .top-wrap .logo-box {
      height: 30px;
      line-height: 30px;
      padding-left: 20px;
    }
    .top-wrap .logo-box img {
      height: 30px;
    }
    .top-wrap .name {
      height: 60px;
      line-height: 60px;
      font-size: 16px;
    }
    .top-wrap .separator {
      height: 18px;
      border-left: 1px solid #e5e5e5;
      margin: 0 16px;
    }
    .content-wrap {
      top: 60px;
    }
    /*.content-wrap .lamp-bg {
      position: relative;
      width: 460px;
      height: 460px;
      background-size: 100%;
    }
    .content-wrap .table-bg {
      position: absolute;
      width: 100px;
      height: 130px;
      background-size: 100%;
    }
    .content-wrap .table-warp1 {
      bottom: 130px;
    }
    .content-wrap .table-warp2 {
      left: 151px;
      top: 43px;
    }
    .content-wrap .table-warp3 {
      right: 50px;
      top: 57px;
    }*/
    .login-wrap {
      width: 280px;
      min-height: 288px;
      margin-top: 115px;
      box-shadow: 0px 10px 30px 0px rgba(0, 0, 0, 0.1);
      -moz-box-shadow: 0px 10px 30px 0px rgba(0, 0, 0, 0.1);
      -webkit-box-shadow: 0px 10px 30px 0px rgba(0, 0, 0, 0.1);
      -ms-box-shadow: 0px 10px 30px 0px rgba(0, 0, 0, 0.1);
    }
    .login-wrap .form-box {
      padding: 29px 54px;
    }
    .content-wrap .input-wrap {
      height: 32px;
    }
    .content-wrap .input-wrap input {
      width: 100px;
    }
    .bottom-wrap {
      bottom: 30px;
    }
    /*@keyframes move1 {
      from { left: 0; bottom: 130px; }
      to { left: 29px; bottom: 158px; }
    }
    @keyframes move2 {
      from { left: 151px; top: 43px; }
      to { left: 180px; top: 14px; }
    }
    @keyframes move3 {
      from { right: 50px; top: 58px; }
      to { right: 22px; top: 29px; }
    }*/
  }
</style>


// WEBPACK FOOTER //
// Login.vue?0e9c6613